import { MeasureLayout } from '../../motion/features/layout/Measure.js';
import { createMotionProxy } from './motion-proxy.js';

/**
 * @public
 */
var m = /*@__PURE__*/ createMotionProxy([MeasureLayout]);

export { m };
